import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MeetingResponse } from '../models/meeting.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface MeetingDrawerOptions {
  meetingId?: number;
  contactId?: number;
  contactName?: string;
  companyId?: number;
  companyName?: string;
  dealId?: number;
  dealName?: string;
  datetimeStart?: string;
  datetimeEnd?: string;
}

@Injectable({ providedIn: 'root' })
export class MeetingDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: MeetingDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly meetingSaved$$ = new Subject<MeetingResponse>();

  readonly state = this.state$.asObservable();
  readonly meetingSaved$ = this.meetingSaved$$.asObservable();

  open(options: MeetingDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(meeting: MeetingResponse): void {
    this.meetingSaved$$.next(meeting);
  }
}
